var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer-wrapper d-flex align-items-center justify-content-center"},[_vm._v("\n  © "+_vm._s(new Date().getFullYear())+" "+_vm._s(_vm.$t('reserved'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }